<template>
  <v-dialog v-model="dialog" persistent width="800px" @keydown.esc="hide">
    <v-form>
      <v-card>
        <v-card-title class="card-panel blue lighten-3">Контрагент от Диджитал Агентства</v-card-title>

        <v-container>
          <v-radio-group v-model="form.daCompanyID">
            <v-radio autofocus label="Нет контрагента DA" value="0" color="red"/>
            <v-radio
              v-for="company in companies"
              :key="company.companyID"
              :label="company.companyName"
              :value="company.companyID"/>
          </v-radio-group>
        </v-container>

        <v-card-actions>
          <v-btn raised @click="hide">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" raised color="primary" :disabled="loading" :loading="loading" @click.prevent="submitAction">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script type="text/javascript">
import api from '@/api'

export default {
  props: [ 'activity', 'da_company' ],
  data: () => ({
    dialog: false,
    loading: false,
    companies: [],
    form: {}
  }),
  methods: {
    edit () {
      this.loading = true
      api.get('companies/listDa').then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.companies = response.data.data
        this.form = { daCompanyID: this.da_company ? this.da_company.companyID : "0" }
        this.dialog = true
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    hide () {
      this.dialog = false
    },
    submitAction() {
      if ( this.da_company && this.form.daCompanyID == this.da_company.companyID ) return this.hide()
      this.loading = true
      api.post('activities/setDa/'+this.activity.activityID, this.form).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.dialog = false
        if ( !response.data.data.affected ) return
        this.$root.$alert('Контрагент DA сохранен')
        this.$emit('updated');
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>
